<template>
  <div id="satellite-radar">
    <img
      class="position-absolute top-0 w-100"
      style="left: 0; right: 0; margin-left: auto; margin-right: auto;"
      :src="'/map/satellite/base.png?bust=' + cacheBuster"
    >
    <img
      class="position-absolute w-100 top-0"
      style="left: 0; right: 0; margin-left: auto; margin-right: auto;"
      src="/map/satellite/outlines.png"
    >
  </div>
</template>

<script>
export default {
  name: 'SatelliteRadar',
  props: {
    cacheBuster: {
      type: Number,
      required: true,
    },
  },
};
</script>
